import { Colors } from "@/enums/Colors";
import { Tooltip, TooltipProps, styled, tooltipClasses } from "@mui/material";

interface LazoTooltipProps extends TooltipProps {
  minWidth?: string;
  maxWidth?: string;
  offset?: number[];
  fontSize?: string;
  fontColor?: string;
}

const LazoTooltip = styled(({ className, minWidth, maxWidth, offset, ...props }: LazoTooltipProps) => (
  <Tooltip
    arrow
    placement="top"
    {...props}
    classes={{ popper: className }}
    slotProps={{
      popper: {
        modifiers: [
          {
            name: "offset",
            options: {
              offset: offset ?? [0, 0],
            },
          },
        ],
      },
    }}
  />
))(({ minWidth, maxWidth, fontSize, fontColor }) => ({
  [`& .${tooltipClasses.tooltip} `]: {
    fontSize: fontSize || ".75rem",
    padding: "1rem 1.5rem",
    borderRadius: "0.8rem",
    backgroundColor: Colors.WHITE,
    color: fontColor || Colors.BLACK,
    boxShadow: `0px -2px 20.1px rgba(101, 101, 101, 0.17)`,
    minWidth: minWidth || "auto", // Use prop or default to "auto"
    maxWidth: maxWidth || "auto",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: Colors.WHITE,
  },
}));

export default LazoTooltip;
